'use strict';

import directive from './directive';

Vue.directive('chosen', directive);


// WEBPACK FOOTER //
// ./src/js/index.js